export const enum UpdateType {
  CREATE_PROVIDER_ACCOUNT = 'CREATE_PROVIDER_ACCOUNT',
  UPDATE_PROVIDER_ACCOUNT = 'UPDATE_PROVIDER_ACCOUNT',
  DELETE_PROVIDER_ACCOUNT = 'DELETE_PROVIDER_ACCOUNT',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  UPDATE_ACCOUNT = 'UPDATE_ACCOUNT',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  CREATE_ASSET = 'CREATE_ASSET',
  UPDATE_ASSET = 'UPDATE_ASSET',
  DELETE_ASSET = 'DELETE_ASSET',
  CREATE_COMPANY_EQUITY = 'CREATE_COMPANY_EQUITY',
  UPDATE_COMPANY_EQUITY = 'UPDATE_COMPANY_EQUITY',
  DELETE_COMPANY_EQUITY = 'DELETE_COMPANY_EQUITY',
  CREATE_REAL_ESTATE = 'CREATE_REAL_ESTATE',
  UPDATE_REAL_ESTATE = 'UPDATE_REAL_ESTATE',
  DELETE_REAL_ESTATE = 'DELETE_REAL_ESTATE',
  CREATE_LIABILITY = 'CREATE_LIABILITY',
  UPDATE_LIABILITY = 'UPDATE_LIABILITY',
  DELETE_LIABILITY = 'DELETE_LIABILITY',
  REFRESH_PROVIDER_ACCOUNT = 'REFRESH_PROVIDER_ACCOUNT',
  SHOW_HIDE_NET_WORTH = 'SHOW_HIDE_NET_WORTH',
}

export const GRAPH_HEIGHT = 200;
export const NET_WORTH_SUBLINE_HEIGHT = 22;
export const RETURNS_CALCULATION_INFO_TOOLTIP =
  'Returns are calculated using time-weighted returns, after advisory fees have been deducted. Time-weighted returns are useful for comparison against other investment strategies. This number might not correlate directly with the value chart. Returns and prices are updated daily and may be up to one day delayed.';
export const EXTERNAL_ACCOUNT_DATA_DISCLOSURE_HEADING = 'External account data disclosure';
export const EXTERNAL_ACCOUNT_DATA_DISCLOSURE =
  'Unmanaged account values based on data feeds collected by third parties or information provided by you (the client) may not be accurate at the time of viewing. Some values are not provided to us on a daily basis.';
export const PERSONAL_PORTFOLIO_DISCLAIMER =
  'This is the performance for the clients personal investments only. Other investment accounts that you manage for them are not included here.';
